// import React, { useEffect, useState } from 'react';
// import { PlusOutlined } from '@ant-design/icons';
// import { Image, Upload, message, Button } from 'antd';
// import type { UploadFile, UploadProps } from 'antd';
// import { FileUpload } from 'common/customIcons';
// import './UploadButton.scss';

// /********************************************************************
//  ****************Image upload system-1 start*************************
//  *******************************************************************/
// type propsType1 = {
//   props: any;
//   btnText?: string;
// };
// export const TFUploadButton1 = ({ props }: propsType1) => {
//   props
//   return (
//     <Upload {...props} className="btnUpload">
//       <Button icon={<FileUpload />} className="w-full flex items-center ">
//         {props.btnText ? props.btnText : 'Upload File'}
//       </Button>
//     </Upload>
//   );
// };

// // Example  (in parent)

// // const [img, setImg] = useState('')
// // const uploadPropsObj = {
// //   btnText: 'Image(Max 1MB)',
// //   name: 'files',
// //   action: `https://app.trackforce.io/api/Document/Upload?orgId=37`,
// //   headers: {
// //       authorization: 'authorization-text',
// //   },
// //   beforeUpload(file: any) {
// //       const isLt2M = file.size / 1024 / 1024 < 1;
// //       if (!isLt2M) {
// //           message.error('Image must smaller than 1MB!');
// //       }
// //       return isLt2M || Upload.LIST_IGNORE;
// //   },
// //   onChange(info: any) {
// //       if (info.file.status === 'done') {
// //           // console.log(info.fileList[0].response.responses[0].globalFileUrlId)
// //           // const a = info.fileList[0].response.responses[0].globalFileUrlId
// //           setImg(info.fileList[0].response.responses[0].globalFileUrlId)

// //           message.success(`${info.file.name} file uploaded successfully`);
// //       } else if (info.file.status === 'error') {
// //           message.error(`${info.file.name} file upload failed.`);
// //       }
// //   },
// //   maxCount: 5,
// //   accept: 'image/gif, image/jpg, image/jpeg, image/png',
// //   progress: {
// //       strokeColor: {
// //           '0%': '#108ee9',
// //           '100%': '#87d068',
// //       },
// //       strokeWidth: 3,
// //       format: (percent: any) => percent && `${parseFloat(percent.toFixed(2))}%`,
// //   },

// // };

// // <TFUploadButton props={uploadPropsObj} />

// /*******************************************************************
//  ********************Image upload system-1 end**********************
//  *******************************************************************/

// /*******************************************************************
//  ********************Image upload system-2 start********************
//  *******************************************************************/

// type FileType = NonNullable<UploadFile['originFileObj']>;

// const getBase64 = (file: FileType): Promise<string> =>
//   new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.readAsDataURL(file);
//     reader.onload = () => resolve(reader.result as string);
//     reader.onerror = (error) => reject(error);
//   });

// interface propsType2 {
//   uploadUrl: string;
//   headers?: Record<string, string>;
//   maxFileSizeMB?: number;
//   maxCount?: number;
//   accept?: string;
//   imgId?:string;
//   setImg: React.Dispatch<React.SetStateAction<string>>;
// }

// // export const TFUploadButton2: React.FC<propsType2> = ({
// //   uploadUrl,
// //   imgId,
// //   setImg,
// //   headers = {},
// //   maxFileSizeMB = 1,
// //   maxCount = 1,
// //   accept = 'image/gif, image/jpg, image/jpeg, image/png',
// // }) => {
// //   const [previewOpen, setPreviewOpen] = useState(false);
// //   const [previewImage, setPreviewImage] = useState('');
// //   const url = `https://app.trackforce.io/api/Document/Download?strImageId=${imgId}`
// //   const [fileList, setFileList] = useState<UploadFile[]>( imgId
// //     ? [
// //       {
// //         uid: '-1',
// //         name: 'image.png',
// //         status: 'done',
// //         url: url,
// //       },
// //     ]
// //     : []);
// //   const handlePreview = async (file: UploadFile) => {
// //     if (!file.url && !file.preview) {
// //       file.preview = await getBase64(file.originFileObj as FileType);
// //     }
// //     setPreviewImage(file.url || (file.preview as string));
// //     setPreviewOpen(true);
// //   };

// //   const handleChange: UploadProps['onChange'] = (info) => {
// //     setFileList(info.fileList);

// //     if (info.file.status === 'done') {
// //       setImg(info.fileList[0].response.responses[0].globalFileUrlId)
// //       // message.success(`${info.file.name} file uploaded successfully`);
// //     } else if (info.file.status === 'error') {
// //       message.error(`${info.file.name} file upload failed.`);
// //     }
// //   };

// //   const uploadButton = (
// //     <div>
// //       <PlusOutlined />
// //       <div style={{ marginTop: 8 }}>Upload</div>
// //     </div>
// //   );

// //   return (
// //     <>
// //       <Upload
// //         name="files"
// //         action={uploadUrl}
// //         headers={headers}
// //         beforeUpload={(file) => {
// //           const isLtMaxSize = file.size / 1024 / 1024 < maxFileSizeMB;
// //           if (!isLtMaxSize) {
// //             message.error(`Image must be smaller than ${maxFileSizeMB}MB!`);
// //           }
// //           return isLtMaxSize || Upload.LIST_IGNORE;
// //         }}
// //         onChange={handleChange}
// //         onPreview={handlePreview}
// //         fileList={fileList}
// //         maxCount={maxCount}
// //         accept={accept}
// //         listType="picture-card"
// //       >
// //         {fileList.length >= maxCount ? null : uploadButton}
// //       </Upload>
// //       <Image
// //         className='!w-[200px] rounded-md'
// //         preview={{
// //           visible: previewOpen,
// //           onVisibleChange: (visible) => {
// //             setPreviewOpen(visible);
// //             if (!visible) setPreviewImage('');
// //           },
// //         }}
// //         src={previewImage}
// //       />
// //     </>
// //   );
// // };

// //     Example

// //     <TFUploadButton2
// //     uploadUrl="https://app.trackforce.io/api/Document/Upload?orgId=37"
// //     headers={{ Authorization: 'Bearer token' }}
// //     maxFileSizeMB={1}
// //     maxCount={1}
// //     accept="image/png, image/jpeg"
// // />
// export const TFUploadButton2: React.FC<propsType2> = ({
//   uploadUrl,
//   imgId,
//   setImg,
//   headers = {},
//   maxFileSizeMB = 1,
//   maxCount = 1,
//   accept = 'image/gif, image/jpg, image/jpeg, image/png',
// }) => {
//   const [previewOpen, setPreviewOpen] = useState(false);
//   const [previewImage, setPreviewImage] = useState('');
//   const [fileList, setFileList] = useState<UploadFile[]>([]);

//   useEffect(() => {
//     if (imgId) {
//       const url = `https://app.trackforce.io/api/Document/Download?strImageId=${imgId}`;
//       setFileList([
//         {
//           uid: '-1',
//           name: 'image.png',
//           status: 'done',
//           url: url,
//         },
//       ]);
//     }
//   }, [imgId]);

//   const handlePreview = async (file: UploadFile) => {
//     if (!file.url && !file.preview) {
//       const reader = new FileReader();
//       reader.onload = () => setPreviewImage(reader.result as string);
//       reader.readAsDataURL(file.originFileObj as Blob);
//     } else {
//       setPreviewImage(file.url || file.preview || '');
//     }
//     setPreviewOpen(true);
//   };

//   const handleChange: UploadProps['onChange'] = (info) => {
//     setFileList(info.fileList);
//     if (info.file.status === 'done') {
//       const uploadedImgId = info.file.response?.responses[0]?.fileUrlId;
//       setImg(uploadedImgId);
//     } else if (info.file.status === 'error') {
//       message.error(`${info.file.name} file upload failed.`);
//     }
//   };

//   const uploadButton = (
//     <div>
//       <PlusOutlined />
//       <div style={{ marginTop: 8 }}>Upload</div>
//     </div>
//   );

//   return (
//     <>
//       <Upload
//         name="files"
//         action={uploadUrl}
//         headers={headers}
//         beforeUpload={(file) => {
//           const isLtMaxSize = file.size / 1024 / 1024 < maxFileSizeMB;
//           if (!isLtMaxSize) {
//             message.error(`Image must be smaller than ${maxFileSizeMB}MB!`);
//           }
//           return isLtMaxSize || Upload.LIST_IGNORE;
//         }}
//         onChange={handleChange}
//         onPreview={handlePreview}
//         fileList={fileList}
//         maxCount={maxCount}
//         accept={accept}
//         listType="picture-card"
//       >
//         {fileList.length >= maxCount ? null : uploadButton}
//       </Upload>
//       {previewOpen && (
//         <Image
//           className="!w-[200px] rounded-md"
//           preview={{
//             visible: previewOpen,
//             onVisibleChange: (visible) => {
//               setPreviewOpen(visible);
//               if (!visible) setPreviewImage('');
//             },
//           }}
//           src={previewImage}
//         />
//       )}
//     </>
//   );
// };

// /*******************************************************************
//  ********************Image upload system-2 end**********************
//  *******************************************************************/

import { Image, message, Upload } from 'antd';
import type { UploadFile, UploadProps } from 'antd/es/upload';
import { BASE_URL } from 'common/config/baseUrl';
import { useGetImageUrl } from 'common/hooks';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import './uploadButton.css';

interface Props {
  accountId: string;
  imgId: string;
  setImg: (id: string) => void;
  maxFileSizeMB?: number;
  maxCount?: number;
  accept?: string;
}

export const TFUploadButton2: React.FC<Props> = ({
  accountId,
  imgId,
  setImg,
  maxFileSizeMB = 1,
  maxCount = 1,
  accept = 'image/gif, image/jpg, image/jpeg, image/png',
}) => {
  const {t} = useTranslation();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const { profileData } = useSelector((state: any) => state?.auth);
  const uploadUrl = `${BASE_URL}/api/Document/Upload?accountId=${accountId}&fileType=image`;
  const { imgUrl } = useGetImageUrl(imgId);
  useEffect(() => {
    if(imgUrl){
       setFileList([
        {
          uid: '-1',
          name: 'image.png',
          status: 'done',
          url: imgUrl ,
        },
      ]);
    }
    
  }, [ imgUrl]);
  

  const handlePreview = async () => {
     if(imgUrl){
      setPreviewImage(imgUrl)
    }
    setPreviewOpen(true);
  };

  // useEffect(() => {
  //   if(imgId) {
  //     setPreviewImage(imgId)
  //     // setPreviewOpen(true);
  //   }
  // },[imgId])

 

  const handleChange: UploadProps['onChange'] = (info) => {
    setFileList(info.fileList);
    if (info.file.status === 'done') {
      const uploadedImgId = info.file.response?.fileUrlId || '';
      if (uploadedImgId) {
        setImg(uploadedImgId);
      }
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  // const uploadButton = (
  //   <div aria-label="Upload Button" title="Upload">
  //     <PlusOutlined />
  //     <div style={{ marginTop: 8 }}>Upload</div>
  //   </div>
  // );

  // console.log('ffffffffffffffff=========',previewImage)
  return (
    <>
      {!previewImage && (
        <>
          <Upload
            name="file"
            action={uploadUrl}
            // className="!w-full"
            headers={{
              accept: '*/*',
              Authorization: `Bearer ${profileData?.token}`,
            }}
            beforeUpload={(file) => {
              const isLtMaxSize = file.size / 1024 / 1024 < maxFileSizeMB;
              if (!isLtMaxSize) {
                message.error(`Image must be smaller than ${maxFileSizeMB}MB!`);
              }
              return isLtMaxSize || Upload.LIST_IGNORE;
            }}
            onChange={handleChange}
            onPreview={handlePreview}
            fileList={fileList}
            maxCount={maxCount}
            accept={accept}
            listType="picture-card"
            className="!w-full  rounded-[8px]  text-center hover:border-primaryColor transition-all duration-300"
          >
            {fileList.length >= maxCount ? null : (
              <div className="flex flex-col !w-full items-center justify-center gap-2">
                {/* <InboxOutlined className="text-2xl text-blue-400" /> */}
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="33"
                    viewBox="0 0 32 33"
                    fill="none"
                  >
                    <path
                      d="M22.2924 21.2075L19.9999 18.9137V26.5C19.9999 26.7652 19.8945 27.0196 19.707 27.2071C19.5195 27.3946 19.2651 27.5 18.9999 27.5C18.7347 27.5 18.4803 27.3946 18.2928 27.2071C18.1052 27.0196 17.9999 26.7652 17.9999 26.5V18.9137L15.7074 21.2075C15.6145 21.3004 15.5042 21.3741 15.3828 21.4244C15.2614 21.4747 15.1313 21.5006 14.9999 21.5006C14.8685 21.5006 14.7384 21.4747 14.617 21.4244C14.4956 21.3741 14.3853 21.3004 14.2924 21.2075C14.1995 21.1146 14.1258 21.0043 14.0755 20.8829C14.0252 20.7615 13.9993 20.6314 13.9993 20.5C13.9993 20.3686 14.0252 20.2385 14.0755 20.1171C14.1258 19.9957 14.1995 19.8854 14.2924 19.7925L18.2924 15.7925C18.3853 15.6995 18.4956 15.6258 18.6169 15.5754C18.7383 15.5251 18.8685 15.4992 18.9999 15.4992C19.1313 15.4992 19.2614 15.5251 19.3828 15.5754C19.5042 15.6258 19.6145 15.6995 19.7074 15.7925L23.7074 19.7925C23.8003 19.8854 23.874 19.9957 23.9243 20.1171C23.9746 20.2385 24.0004 20.3686 24.0004 20.5C24.0004 20.6314 23.9746 20.7615 23.9243 20.8829C23.874 21.0043 23.8003 21.1146 23.7074 21.2075C23.6145 21.3004 23.5042 21.3741 23.3828 21.4244C23.2614 21.4747 23.1313 21.5006 22.9999 21.5006C22.8685 21.5006 22.7384 21.4747 22.617 21.4244C22.4956 21.3741 22.3853 21.3004 22.2924 21.2075ZM19.9999 5.5C17.9568 5.50154 15.9545 6.07152 14.2169 7.14617C12.4793 8.22082 11.075 9.75775 10.1611 11.585C9.07304 11.4251 7.96366 11.4913 6.90229 11.7794C5.84092 12.0675 4.85035 12.5714 3.99245 13.2595C3.13455 13.9476 2.42775 14.8053 1.91619 15.7788C1.40462 16.7524 1.09929 17.821 1.01926 18.9178C0.939225 20.0147 1.08621 21.1163 1.45103 22.1538C1.81585 23.1913 2.39068 24.1424 3.1396 24.9478C3.88853 25.7532 4.79546 26.3955 5.80377 26.8346C6.81208 27.2737 7.9001 27.5003 8.99989 27.5H13.9999C14.2651 27.5 14.5195 27.3946 14.707 27.2071C14.8945 27.0196 14.9999 26.7652 14.9999 26.5C14.9999 26.2348 14.8945 25.9804 14.707 25.7929C14.5195 25.6054 14.2651 25.5 13.9999 25.5H8.99989C7.40859 25.5 5.88246 24.8679 4.75724 23.7426C3.63203 22.6174 2.99989 21.0913 2.99989 19.5C2.99989 17.9087 3.63203 16.3826 4.75724 15.2574C5.88246 14.1321 7.40859 13.5 8.99989 13.5C9.13739 13.5 9.27489 13.5 9.41114 13.515C9.13778 14.4864 8.9994 15.4908 8.99989 16.5C8.99989 16.7652 9.10524 17.0196 9.29278 17.2071C9.48032 17.3946 9.73467 17.5 9.99989 17.5C10.2651 17.5 10.5195 17.3946 10.707 17.2071C10.8945 17.0196 10.9999 16.7652 10.9999 16.5C11.0001 14.8774 11.439 13.2851 12.2701 11.8916C13.1011 10.498 14.2935 9.35506 15.7209 8.58363C17.1484 7.81221 18.7578 7.44102 20.3789 7.50935C22 7.57768 23.5725 8.08299 24.93 8.9718C26.2874 9.86061 27.3793 11.0999 28.0902 12.5584C28.801 14.017 29.1044 15.6405 28.9681 17.2574C28.8318 18.8742 28.2609 20.4241 27.316 21.743C26.371 23.062 25.087 24.101 23.5999 24.75C23.3887 24.8415 23.2156 25.0031 23.1097 25.2075C23.0038 25.4118 22.9717 25.6464 23.0187 25.8717C23.0657 26.097 23.189 26.2992 23.3677 26.4442C23.5465 26.5891 23.7697 26.668 23.9999 26.6675C24.1377 26.6674 24.2739 26.6384 24.3999 26.5825C26.7166 25.5719 28.6146 23.7944 29.7747 21.5489C30.9347 19.3034 31.2862 16.7269 30.7698 14.2527C30.2534 11.7785 28.9008 9.55762 26.9393 7.96358C24.9779 6.36953 22.5274 5.49956 19.9999 5.5Z"
                      fill="#9CA3AF"
                    />
                  </svg>
                </span>
                <p className="text-sm font-medium text-gray-600">
                 {t('employees:addEmployee:chooseDrag')}
                </p>
                <p className="text-xs text-gray-400">
                  {t('employees:addEmployee:jpeg')}
                </p>
                <span className="text-primaryColor font-medium text-sm underline cursor-pointer">
                   {t('employees:addEmployee:browse')}
                </span>
              </div>
            )}
          </Upload>
        </>
      )}
      {previewOpen && (
        <Image
          className="!w-[200px] rounded-[8px]"
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => {
              setPreviewOpen(visible);
              if (!visible) setPreviewImage('');
            },
          }}
          src={previewImage || '/path-to-placeholder.png'}
        />
      )}
    </>
  );
};
